import { dayLabel, fromIsoDay, isoDay } from 'helper/timeLabels';

// The dates of a task, said from today as one would say them: « Aujourd’hui »,
// « Hier », « Il y a 3 jours », « Lundi » (the coming week), else the day itself.

const RELATIVE = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' });
const WEEKDAY = new Intl.DateTimeFormat('fr', { weekday: 'long' });
const capitalize = (words) => words.charAt(0).toUpperCase() + words.slice(1);

// In lower case: « aujourd’hui », « hier », « il y a 3 jours », « lundi », or null past a week.
const relativeDay = (date, now) => {
  const days = Math.round((fromIsoDay(isoDay(date)) - fromIsoDay(isoDay(now))) / 86400000);
  if (days >= -6 && days <= 1) return RELATIVE.format(days, 'day');
  if (days > 1 && days <= 6) return WEEKDAY.format(date);
  return null;
};

// « Aujourd’hui », « Demain », « Hier », « Il y a 3 jours », « Lundi », or « Jeu. 29 oct. ».
export const dueText = (task, now) => {
  const day = fromIsoDay(task.dueOn);
  const relative = relativeDay(day, now);
  return relative ? capitalize(relative) : dayLabel(day);
};

// « 9:30 », or nothing for a task of the whole day.
export const timeText = (task) => (task.dueTime ? task.dueTime.slice(0, 5).replace(/^0/, '') : '');

// « Faite aujourd’hui », « Faite il y a 3 jours », « Faite le lun. 19 oct. » (`verb`: « Terminée » on a kanban card).
export const doneText = (task, now, verb = 'Faite') => {
  const day = new Date(task.doneAt);
  return `${verb} ${relativeDay(day, now) ?? `le ${dayLabel(day).toLowerCase()}`}`;
};

export const isLate = (task, now) => !task.doneAt && task.dueOn < isoDay(now);

// The date of a kanban card: « Demain · 9:30 », « Jeu. 29 oct. », or « Terminée hier » once done.
export const kanbanDateText = (row, now) => {
  if (row.doneAt) return doneText(row, now, 'Terminée');
  const time = timeText(row);
  return time ? `${dueText(row, now)} · ${time}` : dueText(row, now);
};
